var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L9.24081 12.375L0.195722 22H2.19972L10.1259 13.56L16.4284 22H24L14.3456 9.07206L22.8651 0H20.8672L13.4593 7.88364L7.57163 0H0ZM2.39298 1.15789H6.90814L21.607 20.8421H17.0919L2.39298 1.15789Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIc);
export default __webpack_public_path__ + "static/media/x_ic.c2b42e4beb4ac94aecbb6656e026be94.svg";
export { ForwardRef as ReactComponent };